import { render, staticRenderFns } from "./MachinePunchEditor.vue?vue&type=template&id=6c2aa36a&scoped=true&"
import script from "./MachinePunchEditor.vue?vue&type=script&lang=js&"
export * from "./MachinePunchEditor.vue?vue&type=script&lang=js&"
import style0 from "./MachinePunchEditor.vue?vue&type=style&index=0&id=6c2aa36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2aa36a",
  null
  
)

export default component.exports